<template>
  <div class="cp-sidebar__header__container">
    <div class="cp-sidebar__rectangle"></div>
    <div class="cp-sidebar__header">
      <p class="cp-sidebar__header__title" v-html="title"></p>
      <svg @click.stop="$emit('clear')" xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none" class="cp-sidebar__header__cicon">
        <g filter="url(#filter0_d_2439_55251)">
          <g filter="url(#filter1_d_2439_55251)">
            <circle cx="23" cy="19" r="19" fill="#F4F4F4"/>
          </g>
          <path d="M30 26L16 12L30 26ZM30 12L16 26L30 12Z" fill="#FAFAFA"/>
          <path d="M30 26L16 12M30 12L16 26" stroke="#797979" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <filter id="filter0_d_2439_55251" x="0" y="0" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="2"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2439_55251"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2439_55251" result="shape"/>
          </filter>
        </defs>
      </svg>
    </div>
    <hr />
  </div>
</template>

<script>
export default {
  name: 'SidebarHeader',
  props: {
    title: String
  }
}
</script>

<style scoped>

</style>
